import { PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
    auth: {
        clientId: "e234c719-72b7-4302-a3bc-2c3c0c8897d0", // KNAdmin-SPA 
        authority: 'https://login.microsoftonline.com/f6b6dd5b-f02f-441a-99a0-162ac5060bd2/',  //last part of guid = tenantId 
        redirectUri: window.location.origin, // Dynamically grabs https://localhost:44445
        postLogoutRedirectUri: '/', 
        navigateToLoginRequestUrl:  true, //false, 
    },
    cache: {
        cacheLocation: "sessionStorage", // Stores tokens securely for the session
        storeAuthStateInCookie: false,
    }
};

// Request scopes required by your backend Web API
export const loginRequest = {
    scopes: ["api://04502c6b-9193-4324-b4ac-3c8b4b9d551c/access_as_user"]  //KNAdmin-API : expose api scopes 
};

export const msalInstance = new PublicClientApplication(msalConfig);